import { render, staticRenderFns } from "./InTransitReport.vue?vue&type=template&id=a2034550&"
import script from "./InTransitReport.vue?vue&type=script&lang=js&"
export * from "./InTransitReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports